import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styles } from "./UserInputForm.styles";
import { FONT_SIZES } from "../../constants/fontSizes";

const InputAccordion = ({ title, children, expanded }) => {
  return (
    <Accordion sx={styles.accordion} defaultExpanded={expanded}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${title.toLowerCase().replace(/\s+/g, "-")}-content`}
        id={`${title.toLowerCase().replace(/\s+/g, "-")}-header`}
      >
        <Typography
          sx={{
            ...styles.accordionTitle,
            fontSize: FONT_SIZES.PARAGRAPH.xs,
            "@media (min-width: 600px)": { fontSize: FONT_SIZES.PARAGRAPH.sm },
          }}
        >
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

export default InputAccordion;
